import { hooksStore } from "../../stores/hooks.store";
import { userStore } from "../../stores/user.store";
import { tempStore } from "../../stores/temp.store";

import { config } from "./config";

import { vratGeojsonData, zmazRozkopavku } from "../../api/rozkopavky";

import {
  getMap,
  vygenerujIdZdroja,
  sourceExists,
  pridajVrstvy,
  odstranVrstvuZMapy,
  nastavViditelnostVrstvy,
} from "../../helpers/map";
import { vratVrstvyMapyPodlaTypu } from "../../helpers/config";

import { get as get_store } from "svelte/store";

import { Draw } from "../Base/Controls/mapboxDraw";
import set from "set-value";
import get from "get-value";
import { Base64 } from "js-base64";
import _ from "lodash";

hooksStore.addAction(
  `${config.moduleName}_zrusitForrmular`,
  `${config.moduleName}_rozkopavky.func.js`,
  zrusit
);

export function zrusit(source_id_edit, rozkopavka_id) {
  const map = getMap();
  hooksStore.applyFilters(`${config.moduleName}_formReset`);
  hooksStore.applyFilters(`${config.moduleName}_formMessages`, {
    errors: [],
    successes: [],
  });
  hooksStore.doAction(`${config.moduleName}_skryFormular`);

  let store = get_store(tempStore);
  const kresleniaKRozkopavke = get(
    store,
    `kreslenia_${config.moduleName}.` + rozkopavka_id
  );
  if (kresleniaKRozkopavke) {
    kresleniaKRozkopavke.forEach((id) => {
      hooksStore.doAction("zmazKonkretneKreslenie", id);
    });
  }

  if (sourceExists(source_id_edit)) {
    const sourceData = map.getStyle().sources[source_id_edit].data;
    for (let i = 0; i < sourceData.features.length; i++) {
      const typ = sourceData.features[i].geometry.type.toLowerCase();
      nastavViditelnostVrstvy(typ, source_id_edit, "visible", i);
    }
  }

  hooksStore.doAction("editSourceDraw", { features: [] }, null);
}

hooksStore.addFilter(
  "popupFooterButtons",
  `${config.moduleName}_rozkopavky.func.js`,
  popupFooterButtons
);

function popupFooterButtons(constent, source_id) {
  const u = userStore.getUser();
  const modules = get(u, "modules", []);
  if (modules.includes(`module_${config.moduleName}_edit`)) {
    constent += `<span class="pridat-${config.moduleName} active" data-source-id="${source_id}">${config.texts.pridat}</span>`;
  }

  return constent;
}

hooksStore.addAction(
  "popupOvladacieEventy",
  `${config.moduleName}_rozkopavky.func.js`,
  popupOvladacieEventy
);

function popupOvladacieEventy(popupElem, popup) {
  const u = userStore.getUser();
  const modules = get(u, "modules", []);
  /**
   * PRIDAT ROZKOPAVKU
   */
  const pridatRozkopavku = popupElem.querySelector(
    `.footer-buttons .pridat-${config.moduleName}`
  );

  if (pridatRozkopavku) {
    pridatRozkopavku.addEventListener("click", (e) => {
      e.preventDefault();

      const source_id_edit = pridatRozkopavku.getAttribute("data-source-id");
      const geojson = JSON.stringify(popup.sourceData);

      hooksStore.doAction(`${config.moduleName}_zobrazFormular`, {
        geojson,
        popup,
        sourceId: source_id_edit,
      });

      layerNaKreslenie(source_id_edit, null);
    });
  }

  /**
   * ZOBRAZIT Rozkopavku
   */
  const zobrazitRozkopavku = popupElem.querySelector(
    `.footer-buttons .zobrazit-${config.moduleName}`
  );
  if (zobrazitRozkopavku) {
    zobrazitRozkopavku.addEventListener("click", (e) => {
      e.preventDefault();

      const content = zobrazitRozkopavku.closest(".maplibregl-popup-content");
      content.querySelector(".tab-data").classList.remove("active");
      content.querySelector(".tab-poznamka").classList.add("active");

      const footer = zobrazitRozkopavku.closest(".footer-buttons");
      footer.querySelector(".zobrazit-data").classList.add("active");
      if (modules.includes("module_rozkopavky_edit")) {
        footer
          .querySelector(`.upravit-${config.moduleName}`)
          .classList.add("active");
        footer
          .querySelector(`.zmazat-${config.moduleName}`)
          .classList.add("active");
      }

      zobrazitRozkopavku.classList.remove("active");
    });
  }

  /**
   * ZOBRAZIT DATA
   */
  const zobrazitData = popupElem.querySelector(
    ".footer-buttons .zobrazit-data"
  );
  if (zobrazitData) {
    zobrazitData.addEventListener("click", async (e) => {
      e.preventDefault();
      const footer = zobrazitData.closest(".footer-buttons");
      footer
        .querySelector(`.zobrazit-${config.moduleName}`)
        .classList.add("active");
    });
  }

  /**
   * ZOBRAZIT TABULKU
   */
  const zobrazitTabulku = popupElem.querySelector(
    ".footer-buttons .zobrazit-tabulku"
  );
  if (zobrazitTabulku) {
    zobrazitTabulku.addEventListener("click", async (e) => {
      e.preventDefault();
      let rozkopavka_id = e.target.getAttribute("data-rozkopavka-id");
      hooksStore.doAction(
        "nacitajDatagrid",
        hooksStore.applyFilters("resetniANastavFilter", {
          id: rozkopavka_id,
          type: config.moduleName,
          tab: "default",
        })
      );
    });
  }

  /**
   * ZMAZAT ROZKOPAVKU
   */
  const zmazat = popupElem.querySelector(
    `.footer-buttons .zmazat-${config.moduleName}`
  );
  if (zmazat) {
    zmazat.addEventListener("click", (e) => {
      e.preventDefault();

      const source_id_zmazat = zmazat.getAttribute("data-source-id");
      const rozkopavka_id = zmazat.getAttribute("data-rozkopavka-id");

      hooksStore.doAction("confirmDialog", {
        texts: {
          title: config.texts.dialogZmazat.title,
          text: config.texts.dialogZmazat.text,
          confirm: config.texts.dialogZmazat.confirm,
          cancel: config.texts.dialogZmazat.cancel,
        },
        callback: () => {
          zmazatRozkopavku(source_id_zmazat, rozkopavka_id, popup);
        },
      });
    });
  }

  /**
   * UPRAVIT ROZKOPAVKU
   */
  const upravit = popupElem.querySelector(
    `.footer-buttons .upravit-${config.moduleName}`
  );
  if (upravit) {
    upravit.addEventListener("click", (e) => {
      const map = getMap();
      e.preventDefault();

      const source_id_edit = upravit.getAttribute("data-source-id");
      const rozkopavka_id = upravit.getAttribute("data-rozkopavka-id");

      const geojson = JSON.stringify(
        map.getStyle().sources[source_id_edit].data
      );

      const props =
        map.getStyle().sources[source_id_edit].data.features[0].properties;

      hooksStore.doAction(`${config.moduleName}_zobrazFormular`, {
        geojson,
        popup,
        rozkopavka_id,
        sourceId: source_id_edit,
        props,
      });

      layerNaKreslenie(source_id_edit, rozkopavka_id);
    });
  }
}

async function zmazatRozkopavku(source_id, rozkopavka_id, popup) {
  const map = getMap();
  const response = await zmazRozkopavku(config.type, rozkopavka_id);
  if (response.success) {
    map.getStyle().layers.forEach(function (layer) {
      // ak ma layer spravny source, tak ho vymazem
      if (source_id === layer.source) {
        map.removeLayer(layer.id);
      }
    });

    // ak existuje source ktory mam vymazat
    if (map.getSource(source_id)) {
      map.removeSource(source_id);
    }
    if (popup) {
      popup.remove();
    }
    return true;
  } else {
    return false;
  }
}

export async function zobrazRozkopavky() {
  const map = getMap();
  let filtre = vratZoznamAktivnychFiltrov();

  // if (!Array.isArray(filtre) || (Array.isArray(filtre) && !filtre.length)) {
  opravPrepinacVsetkychVrstiev();
  const sources = map.getStyle().sources;
  Object.keys(sources)
    .filter((key) => key.includes(`${config.moduleName}_`))
    .forEach((source_id) => {
      odstranVrstvuZMapy(source_id);
    });
  // }
  const rozkopavky = await vratGeojsonData(config.type, filtre.join(","));
  // ulozVrstvy(rozkopavky);

  const vrstvy = vratVrstvyMapyPodlaTypu(config.type);

  let ids = [];

  if (Array.isArray(rozkopavky) && rozkopavky.length) {
    rozkopavky.forEach(async (rozkopavka) => {
      const id = rozkopavka.features[0].properties.id;
      ids.push(id);
      zobrazRozkopavku(rozkopavka, vrstvy);
    });
    hooksStore.doAction(
      "nacitajDatagrid",
      hooksStore.applyFilters("resetniANastavFilter", {
        id: ids.join(","),
        type: config.type,
        tab: "info",
        // ids: ids,
      })
    );
  }
}

export function zobrazRozkopavku(rozkopavka, vrstvy) {
  const map = getMap();
  const id = rozkopavka.features[0].properties.id;
  const source_id = vygenerujIdZdroja(config.type, id);
  if (!source_id) {
    return false;
  }
  if (vrstvy) {
    // ak uz taky zdroj mam, tak ho nemozem znova pridava
    // ale mozem ho znova nacentrovat
    if (sourceExists(source_id) !== false) {
      for (let i = 0; i < rozkopavka.features.length; i++) {
        const typ = rozkopavka.features[i].geometry.type.toLowerCase();
        nastavViditelnostVrstvy(typ, source_id, "visible", i);
      }
      return false;
    }

    rozkopavka = upravFeaturesDesc(rozkopavka);

    if (!rozkopavka || sourceExists(source_id) !== false) {
      return false;
    }

    // vytvorim si zdroj dat
    map.addSource(source_id, {
      type: "geojson",
      data: rozkopavka,
      generateId: true,
    });

    for (let i = 0; i < rozkopavka.features.length; i++) {
      pridajVrstvy(config.type, id, false, false, false, i);
    }
  }
}

export function upravFeaturesDesc(rozkopavka) {
  const u = userStore.getUser();
  const modules = get(u, "modules", []);

  const id = get(rozkopavka, "features.0.properties.id");
  const source_id = vygenerujIdZdroja(config.type, id);
  if (!source_id) {
    return false;
  }
  for (let i = 0; i < rozkopavka.features.length; i++) {
    const datum_vytvorenia = new Date(
      rozkopavka.features[i].properties.created_at
    );
    const datum_upravy = new Date(rozkopavka.features[i].properties.updated_at);
    let obsah = `<div class="tab-data"></div><div class="tab-poznamka active">`;
    obsah += `<strong>${rozkopavka.features[i].properties.nazov}</strong><br/>`;
    obsah += `<br><p class="info">
              Autor: ${rozkopavka.features[i].properties.user.name}<br />
              Vytvorené: ${datum_vytvorenia.toLocaleDateString("sk-SK", {
                hour: "2-digit",
                minute: "2-digit",
              })}<br />`;
    if (datum_upravy > datum_vytvorenia) {
      obsah += `<br />Upravil: ${
        rozkopavka.features[i].properties.updated_user.name
      }<br />Upravené: ${datum_upravy.toLocaleDateString("sk-SK", {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
      obsah += `</p>`;
    }

    const layer = {
      type: "FeatureCollection",
      features: [],
    };
    layer.features.push(rozkopavka.features[i]);

    obsah += `</div><div class="footer-buttons">
                  <div class="let">
                    <span class="zobrazit-${config.moduleName}">${
      config.texts.zobrazit
    }</span>
                    <span class="zobrazit-data active" data-poznamka-layer="${Base64.encode(
                      JSON.stringify(layer)
                    )}">Zobraziť prieniky</span>
                    <span class="zobrazit-tabulku active" data-rozkopavka-id="${
                      rozkopavka.features[i].properties.id
                    }">Zobraziť tabulku</span>
                  </div>
                  <div class="right">`;
    if (modules.includes("module_rozkopavky_edit")) {
      obsah += `<span class="upravit-${config.moduleName} active" data-source-id="${source_id}" data-rozkopavka-id="${rozkopavka.features[i].properties.id}">Upraviť</span>
                      <span class="zmazat-${config.moduleName} active" data-source-id="${source_id}" data-rozkopavka-id="${rozkopavka.features[i].properties.id}">Zmazať</span>`;
    }
    obsah += `</div>
                </div>`;
    rozkopavka.features[i].properties.description = obsah;
    rozkopavka.features[i].properties._nazov =
      rozkopavka.features[i].properties.nazov;
    rozkopavka.features[i].properties.nazov = null;
  }

  return rozkopavka;
}

export function vratZoznamAktivnychFiltrov() {
  const zoznamAktivnychVrstiev = document.querySelectorAll(
    `#tab${config.moduleNameCamelCase} .filtre input.vrstva:checked`
  );

  const vrstvy = Array.from(zoznamAktivnychVrstiev).map((vrstva) => {
    return vrstva.getAttribute("data-kod");
  });

  return vrstvy;
}

export function opravPrepinacVsetkychVrstiev() {
  const sekcie = document.querySelectorAll(
    `#tab${config.moduleNameCamelCase} .sidebar__wrapper nav > section.box`
  );

  for (let sekcia of sekcie) {
    spocitajAktivne(sekcia);
  }
}

function spocitajAktivne(sekcia) {
  const vsetky = sekcia.querySelectorAll("input.vrstva").length;
  const aktivne = sekcia.querySelectorAll("input.vrstva:checked").length;
  sekcia.querySelector(".box-title small").innerHTML = `(${aktivne}/${vsetky})`;

  let s = sekcia.querySelector(".toggleAll input");
  if (s) {
    s.checked = aktivne && aktivne === vsetky ? true : false;
  }

  const sub = sekcia.querySelectorAll("section.box");
  if (sub.length) {
    for (let sekciaSub of sub) {
      spocitajAktivne(sekciaSub);
    }
  }
}

function ulozVrstvy(aktivneVrstvy) {
  const u = userStore.getUser();
  set(u, `options.mapa.${config.moduleName}`, aktivneVrstvy);

  userStore.updateUser(u);
}

export function nastavVsetkyVrstvy(e) {
  const viditelne = e.target.checked;
  const podvrstvy = e.target
    .closest("section")
    .querySelectorAll(".box-content input");
  for (let checkbox of podvrstvy) {
    checkbox.checked = viditelne;
  }
  zobrazRozkopavky();
}

function layerNaKreslenie(source_id_edit, poznamka_id) {
  if (source_id_edit === "undefined") {
    return;
  }
  const map = getMap();
  const popup = document.getElementsByClassName("maplibregl-popup");
  if (popup.length) {
    popup[0].remove();
  }

  const sourceData = map.getStyle().sources[source_id_edit].data;
  // odstranVrstvuZMapy(source_id_edit);
  /* for (let i = 0; i < sourceData.features.length; i++) {
    const typ = sourceData.features[i].geometry.type.toLowerCase();
    nastavViditelnostVrstvy(typ, source_id_edit, "none", i);
  } */

  nastavViditelnostVrstvy(
    sourceData.features[0].geometry.type === "Point"
      ? "point"
      : config.moduleName,
    source_id_edit,
    "none",
    0
  );

  const kresleniaIds = [];
  for (let i = 0; i < sourceData.features.length; i++) {
    kresleniaIds.push(Draw.add(sourceData.features[i])[0]);
  }

  let store = get_store(tempStore);
  const aktivneKreslenia = Draw.getAll();
  set(store, "kreslenia", aktivneKreslenia);
  set(store, `kreslenia_${config.moduleName}`, { [poznamka_id]: kresleniaIds });
  tempStore.set(store);
}
